import React, {Component} from 'react';
import { ADVANCED_SEARCH, BASIC_SEARCH, ADVANCED_SEARCH_MESSAGE, ADVANCE_SEARCH_TYPE, LS_ADVANCE_SEARCH_KEY } from "../../../../shared/Constants";
import Input from '../../../../UI/Input/Input';
import Button from '../../../../UI/Button/Button';
import { checkValidity } from '../../../../shared/utility';

class AdvancedSearchForm extends Component {

    state = {
        searchForm: {
            firstName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'firstName',
                    placeholder: 'first name',
                    minLength: 2
                },
                value: '',
                validation: {
                    required: false,
                    minlength: 2
                },
                valid: true,
                touched: false,
                label: "First Name",
            },
            lastName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'lastName',
                    placeholder: 'last name',
                    minLength: 2
                },
                value: '',
                validation: {
                    required: false,
                    minlength: 2
                },
                valid: true,
                touched: false,
                label: "Last Name"
            },
            dob: {
                elementType: 'input',
                elementConfig: {
                    type: 'date',
                    id: 'dob',
                    placeholder: 'mm/dd/yyyy',
                    min: '1900-01-01',
                    max: '9999-12-31'
                },
                value: '',
                validation: {
                    required: false,
                    restrictFuture: true
                },
                valid: true,
                touched: false,
                label: "DOB"
            },
            countryCode: {
                elementType: 'inputPhoneCode',
                elementConfig: {
                    type: 'text',
                    id: 'countryCode',
                    minLength: 1,
                    maxLength: 3,
                    pattern: '[0-9]{1,3}',
                    title:'Country Code can only contain numbers'
                },
                value: "",
                validation: {
                    required: false,
                    minlength: 1,
                    maxlength: 3
                },
                valid: true,
                touched: false,
                label: "Country Code",
                inputType: "PhoneCodeAdvSearch",
            },
            phone: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'phone',
                    minLength: 7,
                    maxLength: 20,
                    title:'Format: 999-999-9999'
                },
                value: '',
                validation: {
                    required: false
                },
                valid: true,
                touched: false,
                label: "Phone Number",
                inputType: "PhoneAdvSearch"
            },
            memberId: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'memberId',
                    placeholder: '123456789',
                    maxLength: 40,
                    pattern: '[A-Za-z0-9]{1,40}',
                    title:'Member/Subscriber ID cannot contain special characters'
                },
                value: '',
                validation: {
                    required: false

                },
                valid: true,
                touched: false,
                label: "Subscriber/Member Id"
            },
            ssn: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'ssn',
                    placeholder: 'social',
                    maxLength: 6,
                    pattern: '[0-9]{1,6}',
                    title:'Social can only contain numbers'
                },
                value: '',
                validation: {
                    required: false,
                    minlength: 6,
                    maxlength: 6
                },
                valid: true,
                touched: false,
                label: "SSN(Last 6 digits)"
            },
            email: {
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    id: 'email',
                    placeholder: 'abc.xyz@email.com',
                    pattern:'[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$',
                    title: 'Format: abc.xyz@email.com'
                },
                value: '',
                validation: {
                    required: false

                },
                valid: true,
                touched: false,
                label: "Email Address",
                inputType: "Half"
            },
        },
        formHeader: ADVANCED_SEARCH,
        linkLabel: BASIC_SEARCH,
        msg: ADVANCED_SEARCH_MESSAGE,
        formIsValid: false
    }

    componentDidMount() {
        // console.log("[AdvanceSearchForm] componentWillMount");
        const data = {
            linkLabel: this.state.linkLabel,
            formHeader: this.state.formHeader,
            formMessage: this.state.msg
        };

        this.props.headerHandler(data);
        this.setSearchString();
    }

    componentDidUpdate() {
        //Works for back button , as per req we need to persist last searched query with result when agents click on back button
        window.onpopstate = e => {
            this.setBackNavigationSearchString();
            this.props.setSearchResults();
          }
    }

    setSearchString =()=>{
        this.applySearchRequestToForm(this.props.initialSearchRequest)
    }

    /*
        Back navigation restores from the local storage copy, which outlives a reload,
        while the mount path above intentionally uses the in-memory request only.
    */
    setBackNavigationSearchString = () => {
        this.applySearchRequestToForm(this.props.backNavigationSearch || this.props.initialSearchRequest)
    }

    applySearchRequestToForm = (request) => {
        if (request && request.searchType === ADVANCE_SEARCH_TYPE) {
            this.setInitalSearchForm(request, {...this.state.searchForm})
        }
    }

    setInitalSearchForm = (request, searchForm) => {
        let formIsValid = false;
        for (const [key, value] of Object.entries(request)) {
            if (value && searchForm[key]) {
                searchForm[key] = {
                    ...searchForm[key],
                    value: value,
                    valid: checkValidity(value, searchForm[key].validation).isValid,
                    touched: true
                };
                formIsValid = true;
            }
        }
        for (const key in searchForm) {
            formIsValid = searchForm[key].valid && formIsValid;
        }
        this.setState({searchForm, formIsValid})
    }

    clearSearch = (event) => {
        /*
            This function makes sure to clear the local storage for advance search
            and clear the input values in the current state
        */
        event.preventDefault()
        localStorage.removeItem(LS_ADVANCE_SEARCH_KEY)
        this.props.clearPersistedSearch && this.props.clearPersistedSearch()
        let searchForm = {...this.state.searchForm}
        for (const [key, value] of Object.entries(searchForm)) {
            if (value) {
                searchForm[key].value = "";
                searchForm[key].touched = false;
            }
        }
        this.setState({searchForm, formIsValid: false})
        this.props.clearSearch()
    }

    inputChangedHandler =(event, inputIdentifier) => {

        let updatedForm = {...this.state.searchForm};

        const updatedFormElement = { ...updatedForm[inputIdentifier] };
        updatedFormElement.value = event.target.value;

        if(event.target.value) {
            const validation = checkValidity(updatedFormElement.value, updatedFormElement.validation);
            updatedFormElement.valid = validation.isValid;
            this.props.errorHandler({message: validation.message});
        } else {
            updatedFormElement.valid = true;
            this.props.errorHandler(null);
        }

        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            // console.log("[AdvancedSearc] inputChangedHandler ", formIsValid);
        }

        this.setState({searchForm: updatedForm, formIsValid: formIsValid});
    }

    advancedSearchHandler = (event) => {
        event.preventDefault();
        this.props.clearSearch();
        const invalidFormMessage = this.validateForm();

        // console.log("[AdvancedSearch] advancedSearchHandler -", invalidFormMessage);

        if(!invalidFormMessage) {
            // console.log("[AdvancedSearch] advancedSearchHandler 2 -", invalidFormMessage);
            let formData = {
                searchType: ADVANCE_SEARCH_TYPE
            };
            for(let formElementIdentifier in this.state.searchForm) {
                formData[formElementIdentifier] = this.state.searchForm[formElementIdentifier].value;  
            }
            this.props.searched(formData);
        } else {
            this.props.errorHandler({message: invalidFormMessage});
        }
    }

    validateForm () {
        let counter = 0;
        let ssnSearch = false;
        let searchParams = [];
        for(let formElementIdentifier in this.state.searchForm) {
            let elemValue = this.state.searchForm[formElementIdentifier].value;
            switch(formElementIdentifier) {
                case "memberId":
                    if(elemValue) {
                        // console.log("[AdvancedSearch] advancedSearchHandler memberId ",elemValue);
                        return;
                    }
                    break;
                case "firstName":
                    if(elemValue) {
                        counter = counter+1;
                        searchParams.push("firstName");
                    }
                    break;
                case "lastName":
                    if(elemValue) {
                        counter = counter+1;
                        searchParams.push("lastName");
                    }
                    break;
                case "phone":
                    if(elemValue) {
                        counter = counter+1;
                        if (!searchParams.includes("phone"))searchParams.push("phone");
                    }
                    break;
                case "countryCode":
                    if(elemValue) {
                        counter = counter+1;
                        if (!searchParams.includes("phone"))searchParams.push("phone");
                    }
                    break;
                case "dob":
                    if(elemValue) {
                        counter = counter+1;
                        searchParams.push("dob");
                    }
                    break;
                case "ssn":
                    // console.log("[AdvancedSearch] advancedSearchHandler ssn 1 ", elemValue, elemValue.length>0, ssnSearch);
                    if(elemValue && elemValue.length>0) {
                        counter = counter+1;
                        ssnSearch = true;
                        searchParams.push("ssn");
                    }
                    // console.log("[AdvancedSearch] advancedSearchHandler ssn 2 ", elemValue, elemValue.length>0, ssnSearch);
                    break;
                case "email":
                    if(elemValue) {
                        counter = counter+1;
                        searchParams.push("email");
                    }
                    break;
                default:
                    return 'Invalid search criteria. Pls try again.';
            }
        }

        // console.log("[AdvancedSearch] advancedSearchHandler 3 ",ssnSearch, searchParams, searchParams.includes("firstName"), searchParams.includes("lastName"), searchParams.includes("dob"));

        if(ssnSearch && !(searchParams.includes("firstName") && searchParams.includes("lastName") && searchParams.includes("dob"))) {
            return 'Must enter First name, Last name and Date Of Birth when searching by SSN';
        } else if (counter < 3) {
            return 'Three fields are required to perform an advanced search unless using Member ID';
        } else if (counter == 3 && searchParams.includes("phone") && (
            this.state.searchForm.phone.value === "" || this.state.searchForm.countryCode.value === "")){
            return 'Three fields are required to perform an advanced search unless using Member ID. Please enter a full phone number with Country Code.';
        }

        return;
    }

    render() {

        const formsElementsArray =[];

        for(let key in this.state.searchForm) {
            formsElementsArray.push({
                id: key,
                config: this.state.searchForm[key]
            });
        }

        let searchForm = (
            <form onSubmit={this.advancedSearchHandler}>
                <div>
                    {formsElementsArray.map(formElement => (
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            label={formElement.config.label}
                            changed={(event) => this.inputChangedHandler(event, formElement.id)}
                            extendedInput={formElement.config.extendedInput}
                            inputType={formElement.config.inputType}
                        />
                    ))}
                </div>
                <div style={{display:"flex", justifyContent:"center"}}>
                    <Button attr={{type: "button"}} id="cancelSearch" btnType="Cancel" clicked={this.clearSearch}>Clear All</Button>
                    <Button id="advancedSearch" btnType="Search" disabled={!this.state.formIsValid}>Search</Button>
                </div>
            </form>
        );

        return <div style={{display:'block'}}>{searchForm}</div>;
    }
}

export default AdvancedSearchForm;